/**
 * <strong>Properties:</strong><br>
 * <br>
 * <li>{@link module:mw-form/mixins/property/CheckedMixin|checked}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DescriptionMixin|description}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DisabledMixin|disabled}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TagMixin|tag}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TextMixin|text}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ValidationMixin|validationState, errorText, warningText}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/SizeMixin|width, height}</li>
 * <br>
 * <br>
 * <strong>Events:</strong>
 * <br>
 * <br>
 * <li>{@link module:mw-form/mixins/event/ChangeEventMixin|change}</li>
 * <br>
 * <br>
 * <strong>Example:</strong>
 * <br>
 * <br>
 * For a working example, see the {@link http://inside-files/dev/eps/WIT/WebWidgets/Gallery/Gallery/#checkbox_anchor|gallery}
 * <br>
 * <br>
 * @module mw-form/CheckBox
 *
 * @copyright Copyright 2015-2018 The MathWorks, Inc.
 *
 */

// TODO: Remove _CSSStateMixin dependency, as seen in SplitButton and ToggleSplitButton

define([
    "dojo/_base/declare",
    "dojo/on",
    "dijit/_WidgetBase",
    "dijit/_Contained",
    "dijit/_CssStateMixin",
    "dijit/_FocusMixin",
    "dijit/_TemplatedMixin",
    "mw-form/mixins/property/TagMixin",
    "mw-form/mixins/property/DisabledMixin",
    "mw-form/mixins/property/CheckedMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "mw-form/mixins/property/SizeMixin",
    "mw-form/mixins/property/TextMixin",
    "mw-form/mixins/property/VisualFamilyMixin",
    "mw-form/mixins/property/ValidationMixin",
    "mw-form/mixins/event/ChangeEventMixin",
    "mw-form/mixins/CheckBoxRadioButtonTextSizingMixin",
    "mw-form/mixins/PreventSelectionMixin",
    "mw-form/mixins/mixinDependencyValidator",
    "mw-form/mixins/AriaLabelledByMixin",
    "dojo/text!./templates/CheckBox.html"
], function (declare, on, _WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin,
             TagMixin, DisabledMixin, CheckedMixin, DescriptionMixin, SizeMixin, TextMixin,
             VisualFamilyMixin, ValidationMixin, ChangeEventMixin, CheckBoxRadioButtonTextSizingMixin,
             PreventSelectionMixin, mixinDependencyValidator, AriaLabelledByMixin, template) {

    var SPACE = 32; // Key code for Space

    return declare(mixinDependencyValidator.validate([
        _WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin, TagMixin, DisabledMixin,
        CheckedMixin, DescriptionMixin, SizeMixin, TextMixin, VisualFamilyMixin, ValidationMixin,
        ChangeEventMixin, CheckBoxRadioButtonTextSizingMixin, PreventSelectionMixin, AriaLabelledByMixin
    ]), {

        baseClass: "mwWidget mwCheckBox",
        templateString: template,

        postCreate: function () {
            this.inherited(arguments);
            this.own(
                on(this.domNode, "keydown", this._handleKeydown.bind(this)),
                on(this.domNode, "keyup",   this._handleKeyup.bind(this))
            );
        },

        _handleKeydown: function(e) {
            if (e.keyCode === SPACE) {
                // Prevent scrolling the page
                e.preventDefault();
            }
        },

        _handleKeyup: function(e) {
            if (e.keyCode === SPACE) {
                if (!this.get("disabled")) {
                    e.target.click();
                }
            }
        }
    });
});
